import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PrintService } from './print.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  //API_SERVICE = 'http://127.0.0.1:8000';
  API_SERVICE = 'https://www.laserclinic.mx';

  constructor(private http: HttpClient, private router: Router, private printService: PrintService) {}

  get(module: string): Observable<any> {
    const url = `${this.API_SERVICE}/api/${module}`;

    return this.http.get<any>(url).pipe(retry(1), catchError(this.handleError));
  }

  getFile(module: string,
          options?: {
            params?: HttpParams | { [param: string]: string | number | boolean };
            headers?: HttpHeaders | { [header: string]: string | string[] };
            responseType?: 'json' | 'blob';
            observe?: 'body' | 'response';
          }): Observable<HttpResponse<Blob>> {
    const url = `${this. API_SERVICE}/api/${module}`;

    return this.http.get(url, {
      ...options,
      responseType: 'blob',
      observe: 'response'
    }).pipe(retry(1),catchError(this.handleError));
  }

  getById(module: string, params: number | string): Observable<any> {
    const url = `${this.API_SERVICE}/api/${module}/${params}`;

    return this.http.get<any>(url).pipe(retry(1), catchError(this.handleError));
  }

  create(module: string, params: object): Observable<any> {
    const url = `${this.API_SERVICE}/api/${module}`;

    return this.http
      .post<any>(url, JSON.stringify(params))
      .pipe(retry(1), catchError(this.handleError));
  }

  createFile(module: string, params: object,
             options?: {
            params?: HttpParams | { [param: string]: string | number | boolean };
            headers?: HttpHeaders | { [header: string]: string | string[] };
            responseType?: 'json' | 'blob';
            observe?: 'body' | 'response';
          }): Observable<HttpResponse<Blob>> {

    const url = `${this.API_SERVICE}/api/${module}`;

    return this.http
      .post(url, JSON.stringify(params), {
      ...options,
      responseType: 'blob',
      observe: 'response'
    }).pipe(retry(1), catchError(this.handleError));
  }

  update(module: string, id: number, params: object): Observable<any> {
    const url = `${this.API_SERVICE}/api/${module}/${id}`;

    return this.http
      .put<any>(url, JSON.stringify(params))
      .pipe(retry(1), catchError(this.handleError));
  }

  delete(module: string, id: number): Observable<any> {
    const url = `${this.API_SERVICE}/api/${module}/${id}`;

    return this.http
      .delete<any>(url)
      .pipe(retry(1), catchError(this.handleError));
  }

  login(params: object): Observable<any> {
    const url = `${this.API_SERVICE}/api/login_check`;

    return this.http
      .post<any>(url, JSON.stringify(params))
      .pipe(retry(1), catchError(this.handleError));
  }

  getToken() {
    return localStorage.getItem('access_token');
  }

  getRefreshToken() {
    return localStorage.getItem('refresh_token');
  }

  getTotalCabins() {
    return localStorage.getItem('total_cabins');
  }

  getRoleValue(): Observable<any> {
    const url = `${this.API_SERVICE}/api/employees/roles`;

    return this.http.get<any>(url).pipe(
      map((response: any) => response.user.office.id),
      catchError(this.handleError)
    );
  }

  setTotalCabins(total: any) {
    localStorage.setItem('total_cabins', total);
  }

  get isLoggedIn(): boolean {
    let authToken = this.getToken();

    return authToken !== null;
  }

  get getTotalCabinsPerOffice(): number {
    const totalCabins = Number(this.getTotalCabins());

    return totalCabins;
  }

  /**
   * Function that will return information related
   * to the email to avoid these users block at the moment
   * to create users
   *
   * @param string $email
   * @return boolean
   */
  checkEmailsAdmins(email: string): boolean {
    const emailsArray = [
      'laser.clinic@outlook.es',
      'nallelyleyva@outlook.com',
      'priscila_ahumada@hotmail.com',
      'polethva@icloud.com',
      'direccionlasercli@gmail.com',
      'admin2@test.com',
      'ruben.alonso21@gmail.com'
    ];

    if (emailsArray.includes(email)) {
      return false;
    }

    return true;
  }

  logout() {
    const url = 'logout/office';
    return this.get(url).subscribe({
      next: (logoutData) => {
        if (logoutData.done) {
          let removeToken = localStorage.removeItem('access_token');

          if (removeToken === null || removeToken === undefined) {
            this.router.navigate(['']);
          }
        }
      },
      error: (err) => {
        this.router.navigate(['']);
      },
    });
  }

  handleError(error: any) {
    let errorMessage = '';

    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

  /**
   * Methods for printing tickets
   */

  onPrintRecipient(dataPrinted: any): void {
    console.log("datos: ", dataPrinted);
    let subticket, subticket2;
    const sessionType = (dataPrinted.sessionNumber == 'Anticipo' || dataPrinted.sessionNumber == 'Pagado') 
                        ? dataPrinted.sessionNumber : `${dataPrinted.sessionNumber} / ${dataPrinted.totalSess}`;

    const valueNextDay = (dataPrinted.nextPayment == undefined) ? '' : dataPrinted.nextPayment;
    const sessionTypeNext = (sessionType == undefined) ? '' : sessionType;

    // TJ will be added the 8%
    console.log(dataPrinted.state_code);
    subticket = `<p>DATOS DEL CREDITO</p>
      <p style="text-align: left;">Total del paquete: $ ${new Intl.NumberFormat('es-MX', { style: 'decimal', 
        minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataPrinted.total)}</p>
      <p style="text-align: left;">Total para liquidar hoy: $ ${new Intl.NumberFormat('es-MX', { style: 'decimal', 
        minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataPrinted.remaining)}</p>
      <p style="text-align: left;">Proxima fecha de pago: ${valueNextDay}</p>
      `; //<p style="text-align: left;">Pago: ${sessionTypeNext}</p>

    subticket2 = `<p>DATOS DEL PAQUETE</p>
      <p style="text-align: left;">Total del paquete: $ ${new Intl.NumberFormat('es-MX', { style: 'decimal', 
        minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataPrinted.total)}</p>
      <p style="text-align: left;">Total para liquidar hoy: $ ${new Intl.NumberFormat('es-MX', { style: 'decimal', 
        minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataPrinted.remaining)}</p>
      <p style="text-align: left;">Proxima fecha de pago: ${dataPrinted.nextPayment}</p>
      `; //<p style="text-align: left;">Pago: ${sessionType}</p>

    const ticket1 = `
      <div clss="ticket" style="text-align: center;">
        <img src="https://www.laserclinic.mx/assets/logo.jpeg" alt="Logo" style="width: 8em" />
        <p>LASER CLINIC - ${dataPrinted.office}</p>
        <p style="text-align: left;">Cliente: ${dataPrinted.name} </p>
        <p style="text-align: left; font-weight: bold; font-size: 14px;">Pago actual: $ ${new Intl.NumberFormat('es-MX', { style: 'decimal', 
          minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataPrinted.advance)}</p>
        <p style="text-align: left;">Forma de Pago: ${dataPrinted.type_payment} ${dataPrinted.payment_offer == 'N/A' ? '' : dataPrinted.payment_offer}</p>
        <p style="text-align: left;">Fecha de Pago: ${dataPrinted.date_purchase}</p>
        <p>------------------------------------------</p>
        ${subticket}
        <p>------------------------------------------</p>
        <p style="margin-top: 7px; font-weight: bold;">Copia Sucursal</p>
      </div>
    `;
    const ticket2 = `
     <div class="ticket" style="text-align: center; ${dataPrinted.printerType ? 'margin-top: 5rem' : 'margin-top: 0'}">
        <img src="https://www.laserclinic.mx/assets/logo.jpeg" alt="Logo" style="width: 8em" />
        <p>LASER CLINIC - ${dataPrinted.office}</p>
        <p style="text-align: left;">Cliente: ${dataPrinted.name} </p>
        <p style="text-align: left; font-weight: bold; font-size: 14px;">Abono: $ ${new Intl.NumberFormat('es-MX', { style: 'decimal', 
          minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataPrinted.advance)}</p>
        <p style="text-align: left;">Forma de Pago: ${dataPrinted.type_payment} ${dataPrinted.payment_offer == 'N/A' ? '' : dataPrinted.payment_offer}</p>
        <p style="text-align: left;">Fecha de Pago: ${dataPrinted.date_purchase}</p>
        <p>------------------------------------------</p>
        ${subticket2}
        <p>------------------------------------------</p>
        <p style="margin-top: 7px; font-weight: bold;">Copia Cliente</p>
      </div>
    `;

    // Optional: Add custom thermal-specific styles here if needed, 
    // though general thermal styles are in the service.
    const customStyles = `
      span {
        float: right;
      }
    `;

    const receiptHtml = ticket1 + ticket2;
    // 2. Call the service to print the document
    this.printService.printHtmlDocument(receiptHtml, customStyles, dataPrinted.printerType);
  }

  onPrintRecipientPeninsula(dataPrinted: any): void {
    const calc8 = (dataPrinted.total * 8) / 100;

    const formatMoney = (value: number): string => {
      return new Intl.NumberFormat('es-MX', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    };

    /*
     * Common ticket content
     */
    const bodyTicket = `
      <div class="ticket-body" style="text-align: center;">

        <img
          src="https://www.laserclinic.mx/assets/logo.jpeg"
          alt="Logo"
          style="width: 8em"
        />

        <p>LASER CLINIC - ${dataPrinted.office}</p>

        <p style="text-align: left;">
          FECHA DE PAGO: ${dataPrinted.date_purchase}
        </p>

        <p style="text-align: left;">
          FORMA DE PAGO: ${dataPrinted.type_payment}
        </p>

        <p style="text-align: left;">
          CLIENTE: ${dataPrinted.name}
        </p>

        <p style="text-align: left;">
          TOTAL DEL PAQUETE: $ ${formatMoney(dataPrinted.total)}
        </p>

        <p style="text-align: left;">
          ABONO DEL DIA DE HOY: $ ${formatMoney(dataPrinted.advance)}
        </p>

        <p style="text-align: left;">
          TOTAL PARA LIQUIDAR: $ ${formatMoney(dataPrinted.remaining)}
        </p>

        <p>------------------------------------------</p>

        <p>DATOS DEL PAQUETE</p>

        <p style="text-align: left;">
          FECHA DE CONTRATACIÓN: ${dataPrinted.date_purchase}
        </p>

        <p style="text-align: left;">
          PRECIO DEL PAQUETE: $ ${formatMoney(dataPrinted.total - calc8)}
        </p>

        <p style="text-align: left;">
          % IVA (8.00 %): $ ${formatMoney(calc8)}
        </p>

        <p style="text-align: left;">
          TOTAL DEL PAQUETE: $ ${formatMoney(dataPrinted.total)}
        </p>

      </div>
    `;

    /*
     * Only thermal printers need the large separation
     */
    const clientMargin = dataPrinted.printerType
      ? 'margin-top: 5rem;'
      : '';

    const ticketClient = `
      <div class="ticket" style="text-align: center; ${clientMargin}">

        ${bodyTicket}

        <p>------------------------------------------</p>

        <p style="margin-top: 7px; font-weight: bold;">
          COPIA CLIENTE
        </p>

      </div>
    `;

    const ticketOffice = `
      <div class="ticket" style="text-align: center;">

        ${bodyTicket}

        <p>------------------------------------------</p>

        <p style="margin-top: 7px; font-weight: bold;">
          COPIA SUCURSAL
        </p>

      </div>
    `;

    /*
     * Don't apply generic styles to every div.
     */
    const customStyles = `
      span {
        float: right;
      }

      .ticket {
        box-sizing: border-box;
      }

      .ticket-body {
        width: 100%;
      }
    `;

    const receiptHtml = ticketOffice + ticketClient;
    // 2. Call the service to print the document
    this.printService.printHtmlDocument(receiptHtml, customStyles, dataPrinted.printerType);
  }
}
